<template>
	<!-- Inputs to Open Modal -->
	<div :id="'datepicker_' + variable" class="datepicker-modal modal fade" tabindex="-1" role="dialog">
		<div class="modal-dialog" role="document">
			<div class="modal-content">
				<div class="modal-header">

					<!-- Display Modal Buttons -->
					<div class="modal-actions">

						<div class="title">Select dates</div>
						<button type="button" class="close" @click.prevent="closeModal()" v-if="showClose">
							<i class="apr-icon-close"></i>
						</button>

					</div>

					<!-- Display Selected Dates -->
					<div class="modal-date-selection" v-if="!singleDate">

						<!-- Date 1 Selection -->
						<div class="date-selection-1" :class="{ 'active': activeDate === 'date1' , 'null': date1 === null }" @click="setActiveDate('date1')">
							<div class="date-selection__placeholder">{{ placeholders.date1 }}</div>
							<div class="date-selection__value">	
								<i v-if="date1 === null" class="apr-icon-calendar"></i>
								<span>{{ date1 ? date1.slice(0, -4) : placeholders.date1 }}</span>
							</div>
						</div>

						<!-- Arrow between selections -->
						<div class="arrow" v-if="!singleDate">
							<i class="apr-icon-arrow-right"></i>
						</div>

						<!-- Date 2 Selection -->
						<div class="date-selection-2" :class="{ 'active': activeDate === 'date2', 'null': date2 === null }" @click="setActiveDate('date2')" v-if="!singleDate">
							<div class="date-selection__placeholder">{{ placeholders.date2 }}</div>
							<div class="date-selection__value">
								<i v-if="date2 === null" class="apr-icon-calendar"></i>
								<span>{{ date2 ? date2.slice(0, -4) : placeholders.date2 }}</span>
							</div>
						</div>

					</div>

					<!-- Display Day Names -->
					<div class="day-names">
						<div class="day-name" v-for="dayName in dayNames">{{ dayName }}</div>
					</div>

				</div>
				<div class="modal-body p-0">

					<!-- Calendar List -->
					<calendar ref="calendar" :dayNames="dayNames" :min="minDate" :max="maxDate" width="auto" height="auto"></calendar>

				</div>
				<div class="modal-footer" v-if="!autoclose && !singleDate && date1 && date2 || !autoclose && singleDate && date1">
					<button type="button" class="btn-selection-clear" @click.prevent="clear()" v-if="showClear">clear all</button>
					<button type="button" class="btn-brand-primary" @click="applyModal()">
						Apply
						<i class="apr-arrow-right" aria-hidden="true"></i>
					</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Calendar from './components/Calendar.vue'

	export default {
		name: 'Datepicker',
		components: {Calendar},
		props: {
			variable: {
				type: String,
				default() {
					return 'date'
				}
			},
			autoclose: {
				type: Boolean,
				default() {
					return true
				}
			},
			showClose: {
				type: Boolean,
				default() {
					return true
				}
			},
			showClear: {
				type: Boolean,
				default() {
					return true
				}
			},
			singleDate: {
				type: Boolean,
				default() {
					return false
				}
			},
			dayNames: {
				type: Array,
				default() {
					return ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
				}
			},
			preSelectMin: {
				type: Boolean,
				default() {
					return true
				}
			},
			minDate: {
				type: Date,
				default() {
					return new Date()
				}
			},
			maxDate: {
				type: Date,
				default() {
					return new Date(new Date().setFullYear(new Date().getFullYear() + 5))
				}
			},
			maxDatesBetween: {
				type: Number,
				default() {
					return 0
				}
			},
			placeholders: {
				type: Object,
				default() {
					return {'date1': 'Select Date', 'date2': 'Select Date'}
				}
			},
			title: {
				type: String,
				default() {
					return ''
				}
			},
			allowSameDate: {
				type: Boolean,
				default() {
					return false
				}
			}
		},
		data() {
			return {
				date1: this.$parent.date1,
				dateISO1: this.$parent.dateISO1,
				date2: this.$parent.date2,
				dateISO2: this.$parent.dateISO2,

				activeDate: 'date1',
			}
		},
		mounted() {
			this.$root.$on(this.variable + '_date1', (date) => {
				if (date) {
					// Set Date
					this.dateISO1 = date
					this.date1 = date.toDateString();

					// If auto-close and single dates is true, close modal. Otherwise, set date 2 to active.
					if (this.autoclose && this.singleDate) {
						setTimeout(() => {
							this.applyModal();
						}, 300)
					} else {
						this.activeDate = 'date2';
					}
				}
			});

			this.$root.$on(this.variable + '_date2', (date) => {
				if (date) {

					// Set Date
					this.dateISO2 = date
					this.date2 = date.toDateString();

					// If auto-close is true, close modal on date 2 selection.
					if (this.autoclose) {
						setTimeout(() => {
							this.applyModal();
						}, 300)
					}

					if (!this.dateISO1) {
						this.activeDate = 'date1';
					} else if (this.dateISO1 && this.dateISO2) {
						this.activeDate = '';
					}

				} else {

					// If no date, null out variables.
					this.date2 = null
					this.dateISO2 = null
				}
			});
		},
		methods: {
			openModal(activeDate = 'date1') {
				this.date1 = this.$parent.dates.date1
				this.dateISO1 = this.$parent.dates.dateISO1
				this.$refs.calendar.scrollToDate(new Date(this.dateISO1))
				if(!this.singleDate) {
					this.date2 = this.$parent.dates.date2
					this.dateISO2 = this.$parent.dates.dateISO2
				}

				this.activeDate = activeDate

				this.$root.$emit(this.variable + '_clearSelected')
				this.$root.$emit(this.variable + '_sessionDates', { dateISO1: this.dateISO1, dateISO2: this.dateISO2 })

				$('#datepicker_' + this.variable).modal('show')
			},

			closeModal() {
				$('#datepicker_' + this.variable).modal('hide')
			},

			applyModal() {
				this.$parent.dates = {
					date1: this.date1,
					dateISO1: this.dateISO1,
					date2: this.date2,
					dateISO2: this.dateISO2,
				}
				this.closeModal()
			},

			setActiveDate(date) {
				this.activeDate = date
			},

			clear() {
				this.date1 = null;
				this.date2 = null;
				this.dateISO1 = null;
				this.dateISO2 = null;
				this.activeDate = 'date1'
				this.$root.$emit(this.variable + '_clearSelected')
			}
		}
	}
</script>
